//
export default [
    {
        text: "código interno",
        value: "internal_code",
        width: "15%",
    },
    {
        text: "nombre",
        value: "name",
    },
    {
        text: "cantidad",
        value: "quantity",
        align: "right",
        input: {
            mask: "##########",
            reverse: true,
            type: "text-field",
        },
        width: "15%",
    },
]